module.exports = __webpack_public_path__ + "static/img/model-face.cdd03d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/model-face.png
// module id = 479
// module chunks = 0 1 2 3 4 5 6 7 8